import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import crossImage from 'assets/svg/cross.svg';
import classes from './design-attachments.scss';
const DesignAttachmentsItem = ({
  name,
  src,
  onFileDelete
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.attachment
}, /*#__PURE__*/React.createElement("span", {
  className: classes.attachmentTitle
}, "Attachment"), /*#__PURE__*/React.createElement("div", {
  className: classes.filenameWrapper
}, src ? /*#__PURE__*/React.createElement("a", {
  href: src,
  download: true,
  title: name,
  className: classnames(classes.filename, classes.actionable)
}, name) : /*#__PURE__*/React.createElement("span", {
  title: name,
  className: classes.filename
}, name), /*#__PURE__*/React.createElement("img", {
  src: crossImage,
  role: "button",
  className: classes.removeBtn,
  onClick: onFileDelete
})));
DesignAttachmentsItem.propTypes = {
  name: PropTypes.string.isRequired,
  onFileDelete: PropTypes.func
};
export default DesignAttachmentsItem;